export default "__VITE_ASSET__jaqJ34cY__"